module.exports = __webpack_public_path__ + "media/images/recruitment/products/product-2-79fd70647056eb4c25268db9252fa13b.jpg";